<template>
  <div class="relative">
    <svg class="-scale-x-100" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <g class="fill-transparent stroke-none">
        <circle class="stroke-yapgray-300 stroke-[5px] dark:stroke-yapdarkgray-700" cx="50" cy="50" r="45" />
        <path
          class="stroke-linecap-round origin-center rotate-90 stroke-primary-500 dark:stroke-primary-dark-500 stroke-[5px]"
          :class="{ 'duration-100 ease-linear': props.smooth }"
          :stroke-dasharray="state.circleDasharray"
          d="
            M 50, 50
            m -45, 0
            a 45,45 0 1,0 90,0
            a 45,45 0 1,0 -90,0
          "
        ></path>
      </g>
    </svg>
    <div class="absolute top-0 flex h-full w-full items-center justify-center align-bottom font-mono text-2xl">
      {{ state.formattedRemainingTime }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, reactive, onMounted, watch } from 'vue';

const props = defineProps<{
  timer: number;
  smooth?: boolean;
}>();

const emit = defineEmits(['finished']);

interface State {
  timeElapsed: number;
  timeLeft: number;
  timerInterval?: number;
  formattedRemainingTime: string;
  circleDasharray: string;
  timeFraction: number;
}
const FULL_DASH_ARRAY = 283;
const state: State = reactive({
  timeElapsed: 0,
  timeLeft: computed(() => props.timer - state.timeElapsed),
  timerInterval: undefined,
  formattedRemainingTime: computed(() => {
    const remaining = state.timeLeft;

    const minutes = Math.floor(remaining / 60);
    let seconds: number | string = remaining % 60;

    if (seconds < 10) seconds = `0${seconds}`;

    return `${minutes}:${seconds}`;
  }),
  timeFraction: computed(() => {
    const raw = state.timeLeft / props.timer;
    return raw - (1 / props.timer) * (1 - raw);
  }),
  circleDasharray: computed(() => `${(state.timeFraction * FULL_DASH_ARRAY).toFixed(0)} ${FULL_DASH_ARRAY}`)
});

onMounted(() => {
  state.timerInterval = window.setInterval(() => state.timeElapsed++, 1000);
});

watch(
  () => state.timeLeft,
  (newVal) => {
    if (newVal === 0) {
      clearInterval(state.timerInterval);
      emit('finished');
    }
  }
);
</script>

<style scoped lang="scss">
.stroke-linecap-round {
  stroke-linecap: round;
}
</style>
